import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { AppRoutes } from '../../app-routes'
import { LOGIN_PATH, REGISTER_PATH } from '../../constants/RoutePaths'
import userManager from '../../helpers/UserManager'

const LoginRedirect = () => {
  const history = useNavigate()

  useEffect(() => {
    const getUser = async () => {
      console.log('[LoginRedirect] Starting OIDC callback processing')
      const callbackUser = await userManager.configuration.signinRedirectCallback()
      console.log('[LoginRedirect] Callback completed, state from callback:', callbackUser?.state)

      const user = await userManager.getUserWhenLogin()
      console.log('[LoginRedirect] User retrieved:', {
        hasUser: !!user,
        userState: user?.state,
        callbackState: callbackUser?.state,
      })

      const savedPath = callbackUser?.state || user?.state
      console.log('[LoginRedirect] Saved path to restore:', savedPath)

      if (savedPath && savedPath !== LOGIN_PATH) {
        console.log('[LoginRedirect] Restoring to saved path:', savedPath)
        userManager.configuration.startSilentRenew()
        history(savedPath)
      } else if (user) {
        console.log('[LoginRedirect] No saved path, redirecting to default:', AppRoutes.ASSET_LIST)
        history(AppRoutes.ASSET_LIST)
      } else if (window.location.pathname.includes(REGISTER_PATH)) {
        console.log('[LoginRedirect] Redirecting to registration')
        history(REGISTER_PATH)
      } else {
        console.log('[LoginRedirect] No user found, redirecting to login')
        history(LOGIN_PATH)
      }
    }

    getUser().catch(error => {
      console.error('[LoginRedirect] Error during callback:', error)
      userManager.signIn()
    })
  }, [])

  return <></>
}

export default LoginRedirect
